import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Stack, Typography } from '@mui/material';
import {
  getContractToSign,
  signContract,
} from '../../../../utils/axiosRequests';
import Loading from '../../../molecules/Loading';
import useQuery from '../../../../utils/queryFunctions';
import { useTranslation } from 'react-i18next';

const SignDocument = React.lazy(
  () => import('../../../../utils/SignDocument'),
);

const signatureFields = [
  {
    id: 'signature1',
    page: 5,
    x: 0.1,
    y: 0.7,
    width: 270,
    height: 120,
    required: true,
    label: 'Signature du client',
  },
  {
    id: 'signature2',
    page: 6,
    x: 0.2,
    y: 0.72,
    width: 250,
    height: 60,
    required: true,
    label: 'Signature du client',
  },
];

export default function SignerPage() {
  const { t } = useTranslation('subPro', {
    keyPrefix: 'bankContact',
  });

  const navigate = useNavigate();
  const query = useQuery();
  const request_token = query.get('request_token');

  const [pdfBlob, setPdfBlob] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isBeingSigned, setIsBeingSigned] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (signedPdfBlob) => {
    try {
      setIsBeingSigned(true);
      setErrorMessage(null);

      const formData = new FormData();
      formData.append('file', signedPdfBlob, 'signed_document.pdf');

      await signContract(request_token, formData);

      navigate('/login', { replace: true });
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.message ||
          'Une erreur est survenue lors de la signature du document.',
      );
    } finally {
      setIsBeingSigned(false);
    }
  };

  const handleSign = async () => {
    try {
      setLoading(true);
      setErrorMessage(null);

      const response = await getContractToSign(request_token);

      if (response?.data instanceof Blob) {
        setPdfBlob(response.data);
      } else {
        throw new Error(
          "La réponse n'est pas un fichier PDF valide.",
        );
      }
    } catch (error) {
      setErrorMessage(
        error?.response?.data?.message ||
          error.message ||
          'Impossible de récupérer le document à signer.',
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack
      spacing={2}
      sx={{ maxHeight: '100%', alignItems: 'center', p: 2 }}
    >
      {isBeingSigned ? (
        <>
          <Loading />
          <Typography variant="h5">Signature en cours...</Typography>
        </>
      ) : (
        <>
          <Typography variant="h3" textAlign="center">
            Tout est prêt, vous pouvez signer votre contrat Etiq
          </Typography>

          <Button
            onClick={handleSign}
            disabled={loading}
            color="button"
            variant="contained"
            sx={{
              margin: 'auto',
              fontSize: '20px !important',
              width: 255,
              height: 60,
            }}
          >
            {loading ? (
              <>
                <div style={{ marginRight: 20 }}>
                  <Loading />
                </div>
                Création en cours...
              </>
            ) : (
              t('sub_sign_button')
            )}
          </Button>

          {errorMessage && (
            <Alert
              severity="error"
              sx={{ width: '100%', maxWidth: 600 }}
            >
              {errorMessage}
            </Alert>
          )}

          {pdfBlob && !errorMessage && (
            <SignDocument
              pdfBlob={pdfBlob}
              signatureFields={signatureFields}
              onSubmit={handleSubmit}
            />
          )}
        </>
      )}
    </Stack>
  );
}
